<template>
    <component :is="tag" class="smr-button" :class="['smr-button--' + size, outline ? 'smr-button--outline--' + color : 'smr-button--' + color, round ? 'smr-button--round' : '', icon && iconRight ? 'smr-button--icon-right' : '', customClass]">
      <span class="smr-button__inner">
        <Loader class="smr-button__loader" v-if="loading"/>
        <span class="smr-button__icon" v-if="icon" v-show="!loading"><slot name="icon"/></span>
        <span class="smr-button__text"><slot/></span>
      </span>
  </component>
</template>

<script>
import Loader from '@/components/Loader.vue'
export default {
    props: {
        tag: {
            type: String,
            default: 'div'
        },
        color: {
            type: String,
            default: 'yellow',
        },
        icon: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'default'
        },
        round: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        iconRight: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss">
.smr-button {
    $block: &;
    @include button;

    &--yellow {
        background-color: $color-yellow;
        .no-touch &:hover {
            background-color: $color-yellow-dark;
        }
    }

    &--grey {
        background-color: $color-black-005;
        .no-touch &:hover {
            background-color: $color-black-01;
        }
    }

    &--green {
        background-color: $color-green;
        color: white;
        .no-touch &:hover {
            background-color: lighten($color-green, 5);
        }
    }

    &--outline {
        &--grey {
            border: 1px solid $color-grey-outline;
            background-color: white;
            .no-touch &:hover {
                background-color: $color-grey-lightest;
            }
        }
    }

    &--medium {
        padding: 0 32px;
    }

    &--small {
        height: 40px;
        display: inline-flex;
        padding: 0 10px;
    }

    &--tiny {
        height: 30px;
        display: inline-flex;
        padding: 0 10px;
        font-size: 13px;
        font-weight: $font-weight-medium;
        #{$block} {
            &__loader {
                height: 20px;
                margin-left: -3px;
                margin-right: 3px;
                margin-top: -4px;
            }
            &__icon {
                width: 20px;
                line-height: 1;

                svg {
                    width: 20px;
                    height: 20px;
                    fill: $color-grey-dark;
                }
            }
        }
        &.wide {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
    
    &--round {
        border-radius: 40px;
    }

    &--icon-right {
        position: relative;
        padding-right: 50px;

        #{$block}__icon {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 16px;
            margin: 0;
        }
    }

    &__inner {
        display: flex;
        align-items: center;
        user-select: none;
    }
    &__loader,
    &__icon {
        width: 24px;
        margin-right: 4px;
    }
    &__icon {
        svg {
            display: block;
        }
    }
}
</style>
